export default {
  metadata: {
    version: '1.0.0',
    id: 'footer-market-links-1.0.0',
    name: 'JDSFooterMarketLinks',
    platform: 'web'
  },
  hierarchy: {
    container: [
      'title-jds-text',
      {
        'assets-container': ['image']
      }
    ]
  },
  base: {
    container: {
      gap: '{f_0}',
      'flex-direction': '{f_1}',
      'align-items': '{f_2}'
    },
    'assets-container': {
      'flex-direction': '{f_3}',
      'align-items': '{f_4}',
      gap: '{f_5}'
    },
    image: {
      height: 40,
      'object-fit': 'contain'
    },
    'title-jds-text': {
      'font-family': '{text_91}',
      color: '{text_20}',
      'font-size': '{text_90}',
      'line-height': '{text_92}',
      'letter-spacing': '{text_93}',
      'font-weight': '{text_94}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  api: {
    data: {
      'assets-container': {
        value: {
          name: 'assets',
          type: 'list',
          object: {
            image: 'image'
          }
        }
      },
      image: {
        value: {
          type: 'image',
          name: 'assets.image'
        }
      },
      'title-jds-text': {
        value: {
          type: 'string',
          name: 'title'
        }
      }
    }
  }
};
